import { render } from "./MLRoot.vue?vue&type=template&id=62f37a5e"
import script from "./MLRoot.vue?vue&type=script&lang=js"
export * from "./MLRoot.vue?vue&type=script&lang=js"

import "./MLRoot.vue?vue&type=style&index=0&id=62f37a5e&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__